import { useColorMode, UseColorModeReturn, useDark } from '@vueuse/core'
import { InjectionKey, WritableComputedRef } from 'vue'

// Mode
const isDark = useDark({
  storageKey: 'vueuse-color-mode',
})

const colorMode = useColorMode({
  storageKey: 'vueuse-color-mode',
  emitAuto: true,
})

export type DarkModeProvider = {
  isDark: WritableComputedRef<boolean>
  colorMode: UseColorModeReturn<string>
  updateMode: (isDark: boolean) => void
}

function updateMode(newIsDark: boolean) {
  isDark.value = newIsDark
}

export const darkModeProviderKey: InjectionKey<DarkModeProvider> =
  Symbol() as InjectionKey<DarkModeProvider>
export const darkModeProvider: DarkModeProvider = {
  isDark,
  colorMode,
  updateMode,
}

// Theme
export type Theme = 'default' | 'askodds' | 'askbookmaker' | 'askbet' | 'bet365' | 'totepool' | 'williamhill' | 'betpic'
export type ThemeProvider = {
  theme: UseColorModeReturn<Theme>
  updateTheme: (theme: Theme) => void
}

const themes: Partial<Record<Theme, Theme>> = {
  default: 'default',
	askodds: 'askodds',
	askbookmaker: 'askbookmaker',
  askbet: 'askbet',
  bet365: 'bet365',
  totepool: 'totepool',
  williamhill: 'williamhill',
  betpic: 'betpic'
}

const theme = useColorMode({
  attribute: 'data-theme',
  modes: themes,
  storage: {
    getItem: () => null,
    setItem: () => {},
    removeItem: () => {}
  }
})

function updateTheme(newTheme: Theme) {
  theme.value = newTheme
}

export const themeProviderKey: InjectionKey<ThemeProvider> =
  Symbol() as InjectionKey<ThemeProvider>
export const themeProvider: ThemeProvider = {
  theme,
  updateTheme,
}
